import { get } from "../../api/axiosApi";
import { env } from "utils/env";

const lsngUrl = env.REACT_APP_LSNG_API_URL;

class DashboardApi {
  static getClientOfferData() {
    return get(lsngUrl + "/leasingOffersIndicators/clientofferchartdata");
  }

  static getClientOfferStatusChartData() {
    return get(lsngUrl + "/leasingOffersIndicators/clientofferstatuschartdata");
  }

  static getTopClientsData() {
    return get(lsngUrl + "/leasingOffersIndicators/topclientschartdata");
  }

  static getLatestClientsData() {
    return get(lsngUrl + "/leasingOffersIndicators/latestclientschartdata");
  }
}

export default DashboardApi;
